import { render, staticRenderFns } from "./gs.vue?vue&type=template&id=5c33edd5&scoped=true"
import script from "./gs.vue?vue&type=script&lang=js"
export * from "./gs.vue?vue&type=script&lang=js"
import style0 from "./gs.vue?vue&type=style&index=0&id=5c33edd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c33edd5",
  null
  
)

export default component.exports